import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  wrapper: {
    backgroundColor: "#3b3a3a",
    display: "flex",
    alignItems: "stretch",
    padding: "20px 12px",
    justifyContent: "space-between"
  },
  column: {
    maxWidth: "110px"
  }
});
